$(document).ready(function() {
    // Toggle sharing on .share click
    $('.share').click(function() {
        $('.sharing').toggleClass('is-visible');
    });

    var countdownElement = $('#flash-sale-countdown');

    if (countdownElement.length > 0) {
        var parseDateAsUTC = function(dateStr) {
            // Convert from GMT+7 to UTC
            var date = new Date(dateStr + 'Z');
            return new Date(date.getTime() - (7 * 3600000)); // Adjust from GMT+7 to UTC
        };

        var parseFlashSaleData = function(data) {
            var periods = data.split("*").filter(function(period) {
                return period.trim() !== '';
            }).map(function(period) {
                var parts = period.trim().split(" ");
                return {
                    startTime: parseDateAsUTC(parts[0] + ' ' + parts[1]),
                    endTime: parseDateAsUTC(parts[2] + ' ' + parts[3]),
                    recurrence: parts[4],
                    recurrenceEndDate: parseDateAsUTC(parts[5] + ' ' + parts[6])
                };
            });
            return periods;
        };

        var isSaleActive = function(period, now) {
            var start = new Date(period.startTime.getTime());
            var end = new Date(period.endTime.getTime());
            var recurrence = period.recurrence;

            switch (recurrence) {
                case 'daily':
                    start.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    end.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                    break;
                case 'weekly':
                    var dayDiff = now.getDay() - start.getDay();
                    start = new Date(start.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    end = new Date(end.getTime() + dayDiff * 24 * 60 * 60 * 1000);
                    break;
                case 'monthly':
                    start.setMonth(now.getMonth());
                    end.setMonth(now.getMonth());
                    break;
                case 'one-time':
                    // No change needed for one-time events
                    break;
            }

         // Check against recurrence end date
            if (period.recurrence !== 'one-time' && now > period.recurrenceEndDate) {
                // Check if it's more than a day past the recurrence end date
                var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
                if (now > recurrenceEndPlusOneDay) {
                    return false; // Sale period has ended
                }
            }


          
            return now >= start && now <= end;
        };

        var updateCountdown = function() {
    var nowUTC = new Date(new Date().toUTCString()); // Current UTC time
    var salePeriods = parseFlashSaleData(countdownElement.data('flash-sale'));
    var saleActive = false;
    var nextSaleStarts = null;

    for (var i = 0; i < salePeriods.length; i++) {
        var period = salePeriods[i];
        var start = new Date(period.startTime.getTime());
        var end = new Date(period.endTime.getTime());


         // Skip period if current time is past the recurrence end date
        if (period.recurrence !== 'one-time' && nowUTC > period.recurrenceEndDate) {
            // Check if it's more than a day past the recurrence end date
            var recurrenceEndPlusOneDay = new Date(period.recurrenceEndDate.getTime() + ( 5 * 60 * 1000));
            if (nowUTC > recurrenceEndPlusOneDay) {
                continue;
            }
        }

      
        // Adjust start and end times based on recurrence
        switch (period.recurrence) {
            case 'daily':
                start.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                end.setFullYear(nowUTC.getFullYear(), nowUTC.getMonth(), nowUTC.getDate());
                break;
            case 'weekly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setDate(start.getDate() + 7);
                    end.setDate(end.getDate() + 7);
                }
                break;
            case 'monthly':
                // Find the next occurrence of the sale
                while (start < nowUTC) {
                    start.setMonth(start.getMonth() + 1);
                    end.setMonth(end.getMonth() + 1);
                }
                break;
            // No adjustment needed for one-time events
        }

        // Check if the sale is currently active
        if (nowUTC >= start && nowUTC <= end) {
            var distanceToEnd = end - nowUTC;
            countdownElement.show();
            countdownElement.html("Flash Sale ends in: " + formatCountdown(distanceToEnd));
            saleActive = true;
            break;
        } else if (start > nowUTC) {
            if (!nextSaleStarts || start < nextSaleStarts) {
                nextSaleStarts = start;
            }
        }
    }

    // Display countdown to next sale if not currently active
    if (!saleActive && nextSaleStarts) {
        var distanceToStart = nextSaleStarts - nowUTC;
        if (distanceToStart <= 1 * 60 * 60 * 1000) { // Upcoming sale is within 1 hours
            countdownElement.show();
            countdownElement.html("Flash Sale starts in: " + formatCountdown(distanceToStart));
        } else {
           // countdownElement.html("Next Flash Sale Soon!");
        }
    } else if (!saleActive && !nextSaleStarts) {
    // If no upcoming sale and not currently active, hide the countdown
        clearInterval(interval);
        countdownElement.hide();
        var $section = countdownElement.closest('.shopify-section'); // jQuery object
if ($section.length) {
  $section.hide();
}
      console.log('hide');
    } else if (!saleActive) {
        clearInterval(interval);
        countdownElement.html("Flash Sale Ended");
    }
};

        var formatCountdown = function(distance) {
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            return days + "d " + hours + "h " + minutes + "m " + seconds + "s";
        };

        var interval = setInterval(updateCountdown, 1000);
        updateCountdown();

      var $flashSaleCountdown = $('#flash-sale-countdown');
if ($flashSaleCountdown.length && !$flashSaleCountdown.text().trim()) {
  var $shopifySection = $flashSaleCountdown.closest('.shopify-section');
  if ($shopifySection.length) $shopifySection.hide();
}

    }
});
